/*
 * graph-config.js - Add space between titles and graphic
 */
/* jshint esversion: 6 */
'use strict';

jQuery(document).ready(function() {
    const original = Sao.View.Graph.Chart.prototype._c3_config;
    Sao.View.Graph.Chart.prototype._c3_config = function(data) {
        try {
            const c3_config = original.call(this, data);

            c3_config.axis = c3_config.axis || {};
            c3_config.axis.x = c3_config.axis.x || {};
            c3_config.axis.x.height = 45;

            c3_config.tooltip = c3_config.tooltip || {};
            c3_config.tooltip.order = null;

            return c3_config;
        } catch (err) {
            return original.call(this, data);
        }
    };
});
